import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { IconButton, Popper, Grid, Button, ClickAwayListener } from '@material-ui/core';
import { ArrowDropDownOutlined } from '@material-ui/icons';
import parse from 'html-react-parser';
import useStyles from './CurrentLocation.styles';
import CurrentLocationInputField from '../CurrentLocationInputField/CurrentLocationInputField';

const CurrentLocation = () => {
  const classes = useStyles();
  const reverseGeocodeLocation = useSelector((state) => state.location.reverseGeocodeLocation);
  const [anchorEl, setAnchorEl] = useState(null);
  const [location, setLocation] = useState('');
  const locationInputFieldRef = useRef();

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const handleInputChange = (value) => {
    setLocation(value);
  };

  const settingNewLocation = () => {
    handleClickAway();
    setLocation('');
  };

  const showPopper = Boolean(anchorEl);

  return (
    <span className={classes.location}>
      {parse(
        `near&nbsp;<b>${
          reverseGeocodeLocation && reverseGeocodeLocation.length ? reverseGeocodeLocation : 'Unknown'
        }</b>`
      )}
      <IconButton className={classes.iconBtn} onClick={handleClick}>
        <ArrowDropDownOutlined />
      </IconButton>
      <Popper open={showPopper} anchorEl={anchorEl}>
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className={classes.formContainer}>
            <Grid container direction="row" justify="flex-start">
              <Grid item>
                <CurrentLocationInputField
                  ref={locationInputFieldRef}
                  handleInputChange={handleInputChange}
                  settingNewLocation={settingNewLocation}
                />
              </Grid>
            </Grid>
            <Grid className={classes.btnContainer} container direction="row" justify="flex-end">
              <Grid item>
                <Button
                  className={classes.btn}
                  classes={{ disabled: classes.btnDisabled }}
                  size="small"
                  disabled={!location.trim().length}
                  onClick={() => locationInputFieldRef.current.setNewLocation()}
                >
                  Done
                </Button>
              </Grid>
            </Grid>
          </div>
        </ClickAwayListener>
      </Popper>
    </span>
  );
};

export default CurrentLocation;
